import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { Label } from '../components/ui/label';
import { Input } from '../components/ui/input';
import { Badge } from '../components/ui/badge';
import { User, Mail, Shield, Building2 } from 'lucide-react';

const nivelAcessoLabels = {
  super_admin: 'Super Admin',
  admin_igreja: 'Admin da Igreja',
  admin_congregacao: 'Admin de Congregação',
  usuario_subcongregacao: 'Usuário de Subcongregação',
};

export const Configuracoes = () => {
  const { user } = useAuth();

  return (
    <div className="space-y-6 animate-fade-in" data-testid="configuracoes-page">
      {/* Header */}
      <div>
        <h1 className="page-title">Configurações</h1>
        <p className="page-subtitle">Gerencie suas configurações e perfil</p>
      </div>

      {/* Profile Card */}
      <Card className="stat-card">
        <CardHeader>
          <CardTitle className="card-title flex items-center gap-2">
            <User className="w-5 h-5 text-sky-500" />
            Meu Perfil
          </CardTitle>
          <CardDescription>Informações da sua conta</CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="flex items-center gap-6">
            <div className="w-20 h-20 rounded-full bg-sky-100 flex items-center justify-center">
              <span className="text-3xl font-bold text-sky-600">
                {user?.nome?.charAt(0)?.toUpperCase() || 'U'}
              </span>
            </div>
            <div>
              <h3 className="text-xl font-semibold text-slate-900">{user?.nome}</h3>
              <div className="flex items-center gap-2 mt-1">
                <Mail className="w-4 h-4 text-slate-400" />
                <span className="text-slate-500">{user?.email}</span>
              </div>
              <div className="flex items-center gap-2 mt-2">
                <Badge variant="secondary" className="bg-sky-50 text-sky-700">
                  <Shield className="w-3 h-3 mr-1" />
                  {nivelAcessoLabels[user?.nivel_acesso] || user?.nivel_acesso}
                </Badge>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-4 border-t">
            <div>
              <Label className="text-slate-500">Nome</Label>
              <Input value={user?.nome || ''} disabled className="mt-1 bg-slate-50" />
            </div>
            <div>
              <Label className="text-slate-500">E-mail</Label>
              <Input value={user?.email || ''} disabled className="mt-1 bg-slate-50" />
            </div>
            <div>
              <Label className="text-slate-500">Nível de Acesso</Label>
              <Input 
                value={nivelAcessoLabels[user?.nivel_acesso] || user?.nivel_acesso || ''} 
                disabled 
                className="mt-1 bg-slate-50" 
              />
            </div>
            <div>
              <Label className="text-slate-500">Papéis</Label>
              <Input 
                value={user?.papeis?.join(', ') || '-'} 
                disabled 
                className="mt-1 bg-slate-50" 
              />
            </div>
          </div>
        </CardContent>
      </Card>

      {/* System Info */}
      <Card className="stat-card">
        <CardHeader>
          <CardTitle className="card-title flex items-center gap-2">
            <Building2 className="w-5 h-5 text-emerald-500" />
            Sobre o Sistema
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div>
              <p className="text-sm text-slate-500">Sistema</p>
              <p className="font-semibold text-slate-900">Igreja360</p>
            </div>
            <div>
              <p className="text-sm text-slate-500">Versão</p>
              <p className="font-semibold text-slate-900">1.0.0</p>
            </div>
            <div>
              <p className="text-sm text-slate-500">Ambiente</p>
              <Badge variant="secondary" className="bg-emerald-50 text-emerald-700">
                Produção
              </Badge>
            </div>
            <div>
              <p className="text-sm text-slate-500">Suporte</p>
              <p className="font-semibold text-sky-600">suporte@igreja360.com</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Configuracoes;
